import { SxProps, Theme } from '@mui/material';
import { dialogFormColumn } from '../../theme/mixins';

export const descriptionStyles: SxProps<Theme> = { color: 'text.secondary', mb: 2 };

export const formAlertStyles: SxProps<Theme> = { mb: 2 };

export const reasonFieldStyles: SxProps<Theme> = { mt: 1 };

export const blockedHintStyles: SxProps<Theme> = { mr: 'auto' };

/** Lets the field scroll under a pinned footer -- see `dialogFormColumn`. */
export const dialogFormStyles: SxProps<Theme> = dialogFormColumn;
